// extracted by mini-css-extract-plugin
module.exports = {"InputDate":"DashBoardTraining_InputDate__3OD7Z"};